<template>
  <!-- 菜单管理 -->
  <div class="page">
    <!-- 表格 -->
    <DiluTable :list="tableData" :tableConfig="tableConfig">
      <el-table-column prop="menuName" :label="$t('pages.system.text79')" width="200">
      </el-table-column>
      <el-table-column prop="level" :label="$t('pages.system.text80')" width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.level == 1">{{$t('pages.system.text81')}}</span>
          <span v-else-if="scope.row.level == 2">{{$t('pages.system.text82')}}</span>
          <span v-else-if="scope.row.level == 3">{{$t('pages.system.text83')}}</span>
          <span v-else>{{$t('pages.system.text84')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="url" :label="$t('pages.system.text85')" width="290" align="center">
      </el-table-column>
      <el-table-column prop="hidden" :label="$t('pages.system.text86')" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.level != 4">{{
            scope.row.hidden ? $t('pages.system.text87') : $t('pages.system.text88')
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="address" :label="$t('public.text4')" align="center">
        <template slot-scope="scope">
          <div class="table-operation" v-if="scope.row.level > 3">
            <el-button
              @click="editButton(scope.row)"
              type="text"
              v-permission="['menuManagement:edit']"
              >{{$t('button.edit')}}</el-button
            >
            <el-button
              @click="removeButton(scope.row)"
              type="text"
              v-permission="['menuManagement:remove']"
              >{{$t('button.delete')}}</el-button
            >
          </div>
          <div class="table-operation" v-else>
            <el-button
              @click="edit(scope.row)"
              type="text"
              v-permission="['menuManagement:edit']"
              >{{$t('button.edit')}}</el-button
            >
            <el-button
              @click="remove(scope.row)"
              type="text"
              v-permission="['menuManagement:remove']"
              >{{$t('button.delete')}}</el-button
            >
            <el-button
              v-permission="['menuManagement:add']"
              @click="add(scope.row)"
              type="text"
              v-if="scope.row.level < 3"
              >{{$t('button.addSubmenu')}}</el-button
            >
            <el-button
              v-permission="['menuManagement:add']"
              @click="addButton(scope.row)"
              type="text"
              v-else-if="scope.row.level == 3"
              >{{$t('button.addButton')}}</el-button
            >
          </div>
        </template>
      </el-table-column>
    </DiluTable>

    <!-- 新增弹窗 -->
    <MenuManagementAdd
      @dialogClose="dialogClose"
      @listWithButtons="listWithButtons"
      :dialogVisible="dialogVisible"
      :currentMenu="currentMenu"
      :isAdd="isAdd"
    />

    <!-- 新增按钮 -->
    <MenuManageButtonAdd
      @dialogButtoClose="dialogButtoClose"
      :dialogButtoVisible="dialogButtoVisible"
      :currentMenu="currentMenu"
      @listWithButtons="listWithButtons"
      :isButtonAdd="isButtonAdd"
    />
  </div>
</template>


<script>
import DiluTable from "../../../components/pubilc/dilu-table.vue";
import MenuManagementAdd from "./module/menuManagementAdd.vue";
import MenuManageButtonAdd from "./module/menuManageButtonAdd.vue";
export default {
  data() {
    return {
      isButtonAdd: true,
      isAdd: true,
      dialogButtoVisible: false, //按钮弹窗
      dialogVisible: false, //新增编辑弹窗
      tableConfig: {
        isTree: true,
        isTreeText: "id",
        isPage: false,
      },
      tableData: [],
      currentMenu: {}, //当前菜单
    };
  },
  components: {
    DiluTable,
    MenuManagementAdd,
    MenuManageButtonAdd,
  },
  mounted() {
    this.listWithButtons();
  },
  methods: {
    //新增按钮
    addButton(e) {
      this.isButtonAdd = true;
      this.currentMenu = e;
      this.dialogButtoVisible = true;
    },
    //编辑按钮
    editButton(e) {
      this.isButtonAdd = false;
      this.currentMenu = e;
      this.dialogButtoVisible = true;
    },
    //删除按钮
    removeButton(e) {
      this.$confirm(this.$t('pages.system.text89'), this.$t('public.text6'), {
        confirmButtonText: this.$t('button.determine'),
        cancelButtonText: this.$t('button.cancel'),
        type: "warning",
      })
        .then(() => {
          let str = "?id=" + Math.abs(e.id);
          this.request.menuManagementDeleteButton(str).then(() => {
            this.$message.success(this.$t('public.text7'));
            this.listWithButtons();
          });
        })
        .catch(() => {});
    },
    //关闭按钮弹窗
    dialogButtoClose() {
      this.dialogButtoVisible = false;
    },
    //关闭新增编辑弹窗
    dialogClose() {
      this.dialogVisible = false;
    },
    //获取菜单列表
    listWithButtons() {
      this.request.listWithButtons().then((res) => {
        this.tableData = res.data;
      });
    },
    //新增
    add(e) {
      this.isAdd = true;
      this.currentMenu = e;
      this.dialogVisible = true;
    },
    //编辑
    edit(e) {
      this.isAdd = false;
      this.currentMenu = e;
      this.dialogVisible = true;
    },
    //删除
    remove(e) {
      this.$confirm(this.$t('pages.system.text90'), this.$t('public.text6'), {
        confirmButtonText: this.$t('button.determine'),
        cancelButtonText: this.$t('button.cancel'),
        type: "warning",
      })
        .then(() => {
          let str = "?id=" + e.id;
          this.request.menuManagementDelete(str).then(() => {
            this.$message.success(this.$t('public.text7'));
            this.listWithButtons();
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.page {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.from {
  float: left;
  display: flex;
}
.searchSubmit {
  float: right;
  display: flex;
}
.operation {
  margin-bottom: 20px;
  display: flex;
}
</style>